export default function confirmDelete() {
    return confirm("Deleting this may remove any references to where it's been used. Are you sure you wish to continue?");
}

export function findDeleteButtons() {
    $('.btn, .btn-floating').each((index, btn) => {
        if(btn.textContent.trim() === "delete") {
            $(btn).click(confirmDelete)
        }
    });
}